/** * 通用Column构建器 ***/
import CheckerColumnBuilder from './checker';
import SequenceColumnBuilder from './sequence';
import MedalSequenceColumnBuilder from './medalSequence';
import DateColumnBuilder from './date';
import CountryColumnBuilder from './country';
import PublisherClassColumnBuilder from './publisherClass';
import ActionsColumnBuilder from './actions';
/** * 通用Column构建器 ***/

/** * 指标Column构建器 ***/
import KMBMetricColumnBuilder from './kmbMetric';
/** * 指标Column构建器 ***/

// 通用Column构建器
export const CommonColumnBuilders = {
  // Checkbox勾选Column构建器
  buildCheckerColumn: CheckerColumnBuilder,
  // Sequence Column构建器
  buildSequenceColumn: SequenceColumnBuilder,
  // 奖牌序号Column构建器（前三名显示奖牌图标）
  buildMedalSequenceColumn: MedalSequenceColumnBuilder,
  // 日期Column构建器
  buildDateColumn: DateColumnBuilder,
  // Country Column构建器
  buildCountryColumn: CountryColumnBuilder,
  // Publisher Class Column构建器
  buildPublisherClassColumn: PublisherClassColumnBuilder,
  // KMB指标Column构建器
  buildKMBMetricColumn: KMBMetricColumnBuilder,
  // Actions Column构建器
  buildActionsColumn: ActionsColumnBuilder,
};
